import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import ColorSelectorModal from '../../common/controls/colorSelectorModal';
import { enabledSelector, labelSelector, newPathSelector, valueSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import annTools from '../../common/pdf/annotations/commonAnnotationTools';
import Label from './label';
import logValueOnChange from '../commonActions/logValueOnChange';

/**
 * @class ColorPickerField
 */
const ColorPickerField = _ref => {
  let enabled = _ref.enabled,
    options = _ref.format.options,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    onChange = _ref.onChange,
    _ref$testingIdentifie = _ref.testingIdentifier,
    testingIdentifier = _ref$testingIdentifie === void 0 ? 'default-id' : _ref$testingIdentifie,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? {} : _ref$value,
    path = _ref.path;
  const handleChange = newColor => {
    const updatedColor = annTools.toSaveColor(newColor, 'object');
    return onChange({
      path,
      value: updatedColor
    });
  };
  const className = 't-cpf';
  const testID = "".concat(className, "-").concat(kebabCase(testingIdentifier));
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(testID, "-form"),
    "data-testid": "color-picker-form"
  }, label && /*#__PURE__*/React.createElement(Label, {
    value: label,
    style: {
      height: '32px'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(ColorSelectorModal, {
    selectedColor: value,
    onChange: handleChange,
    indicatorShape: "rectangle",
    disabled: !enabled,
    colorOptions: options
  })));
};
ColorPickerField.propTypes = {
  enabled: PropTypes.bool.isRequired,
  format: PropTypes.shape({
    options: PropTypes.arrayOf(PropTypes.shape({
      red: PropTypes.number,
      green: PropTypes.number,
      blue: PropTypes.number
    }))
  }).isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  testingIdentifier: PropTypes.string,
  path: PropTypes.string.isRequired,
  value: PropTypes.shape({})
};
export { ColorPickerField as UncomposedColorPickerField };
export default entityComposition(ColorPickerField, [], {
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector
});